var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCaution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "url(#pattern0_18_401)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_18_401",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_18_401",
    transform: "scale(0.0232558)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_18_401",
    width: 43,
    height: 43,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAADK0lEQVRYhdXZQWgcVRjA8d/MNtJDyCZErDSgbSpJ6SmhiBGEaqXgIXhRj1rTCh7aix4U9KxHEa0HoZpS7cmeBKFgixcPVoVaD5JarViNUi+xidDidjce5iXdxM3szOwk2/xvb2fe9/13hnkz3/eiG0fe0QHDeAwT2I2d6EUV1/EPfsEMvsIXuFI02ZYCc6o4hGcx3ua8KobwCF4Iv1/AR/hQ8ocyE+c4txdv4CreaiOaxniY/2uI15t1YlbZpyS38jX05bVbg2qINxPit6Wd7FYcx2nJ7VwPhkL84yHfmqTJ9uMMDpfnlcrhkK9/rRPWkh2UPLn71kEqjX0h72Crg61Wg634DGO5U1ViPVNPqOy5T/2Hq2rTZ6g38kYZC/kfxc3mA62u7Nt4KLcoKntHVMZ2cVePytgulb0jRcII+d9b/eNq2afxYtEM0d3V1HFODgWfZZpl+3Csk+jrwLualspm2VewbcN10rkXry4NlmT7cbQrOu05IixnS7LPS94odyJVid+y7MGuqWTjIInsTkXW1I1lDMMxHu+2SUb2x5IP583ARIzRbltkZDTGjm5bZGRHrLyP6fWmb9PJznfbIiPzm0l2IZZUmZuB32JJdbkZmInxbWnh/q2ljzvj6xhny4pW//4KtVvJoHYrGZfH2Sj0ui4o6WMm2jYgfmBI46dZi9fmyggJ32F8qbr9WEmyi9fm1MuTXOIkt79nP3DnLmHzmOa27N9KKhaj7YMqD+8RbW/ZpyjCMYmfqKk/W8WPuKdo1MqDo3qeO0AUsbiodvJz9W8udSL6F0aE1mhzdXtdh0XjlsmJRBSiKBl3xlFNPdzVTY5P8H7RyNFAb+o4J9PBZ5lW7aOXcL5I9Mal31PHOTgvKcFX0Er2BiZxMW+G2qlzGpdnqTc0Ls+qnTqXXzPJOxk8VhClbIAM4FPJfsBG8SWeRMuFOq2ZPIcDOFG+U0tOhHxrvlHatelvYgrP4M/StFbyR4g/ZVU/djVZN0BOS6rgN5X3ppsP8XaH+G3Js7W0gNcl1fDLCjyAgYth/v0h3kLWiWkPWBaGsd//dxj7JFeu1Q7jz0WT/Qd9A7CJGkefrQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaution);
export default __webpack_public_path__ + "static/media/icon_caution.37d8b2cf27451252ab047ea862c9b32b.svg";
export { ForwardRef as ReactComponent };